import { useEffect, useState } from "react";
import { format } from "date-fns";
import "./NewsroomPage.css";
import Instance from "../../Utils/Axios";
import error from "../../Utils/Icons/error";
import PremiumLoader from "../Loader/PremiumLoader";
const NewsRoomPage = () => {
  const [newsroomList, setNewsroomList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true)
    const token = localStorage.getItem("tokenId");
    const newsroomData = () => {
      Instance.post("/site/newsroom/list", {
      }).then((response) => {
        setNewsroomList(response?.data?.message);
        setLoading(false)
      })
        .catch((error) => {
          console.error("Error fetching the news room data", error);
          setLoading(false)
        })
    }
    newsroomData();
  }, [])



  return (
    <>
      {loading ? (
        <PremiumLoader text="Loading Newsroom..." />
      ) : (
        <div className="newsroom_container">
          <div className="newsroom_layout">
            <div className="newsroom_details">
              <h4 className="newsroom_title">Newsroom</h4>
              <div className="newsroom_news">
                {(newsroomList || []).length === 0 ? (
                  <h5>No News Available</h5>
                ) : (
                  (newsroomList || []).map((news, index) => {
                    const getDynamicRoute = (pageLink) => {
                      if (!pageLink) return null;
                      try {
                        const url = new URL(pageLink);
                        const parts = url.pathname.split("/").filter(Boolean);
                        // expects /newsroom/184/slug
                        const id = parts[1];
                        const slug = parts.slice(2).join("/");
                        return `/customer/newsroom/${id}/${slug}`;
                      } catch (e) {
                        return null;
                      }
                    };

                    const dynamicRoute = getDynamicRoute(news.pageLink);

                    return (
                      <div
                        className="news_info"
                        key={index}
                        onClick={() => {
                          if (dynamicRoute) {
                            window.open(dynamicRoute, "_blank");
                          } else if (news.pageLink) {
                            window.open(news.pageLink, "_blank");
                          }
                        }}
                      >
                        <h5>{news.title}</h5>
                        <p>
                          {news.createdOn
                            ? format(new Date(news.createdOn), "MMM d, yyyy • h:mm a")
                            : "N/A"}
                        </p>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
            {/* <div className="pr_details">
              <h4 className="newsroom_title">Related Company PR</h4>
              <div className="newsroom_pr">
                <div className="pr_info">
                  <h5>Real Estate in Turkey</h5>
                  <p>
                    Blockchain-based social network BSocial arrives with a gathering
                    of distinctive features.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default NewsRoomPage;